import React, { useEffect, useState } from "react"
import { useTranslation } from "next-i18next"
import { Button } from "@kohler-dsm-library/kohler-core"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import Style from "@/components/PartsViewer/v2/PartViewerFeedback/feedback.module.scss"
import { showMedalliaFeedbackModal } from "@/services/medallia"
import { MEDALLIA_FORM_ID } from "@/components/PartsViewer/v2/utils"

const PartViewerFeedback = props => {
  const { loading = true } = props || {}
  const { t } = useTranslation()
  const { feedbackText } = getTranslations(t)
  const [formLoaded, setFormLoaded] = useState(false)

  useEffect(() => {
    if (window?.KAMPYLE_ONSITE_SDK) {
      const formLoadedT = window?.KAMPYLE_ONSITE_SDK?.loadForm(MEDALLIA_FORM_ID)
      setFormLoaded(formLoadedT)
    }
  }, [])

  return (
    <div className={Style.PartViewerFeedbackContainer}>
      {loading && formLoaded ? (
        <Button
          className="provide-feedback-button"
          aria-label={feedbackText}
          label={feedbackText}
          size="small"
          variant="active"
          flexible={true}
          type="button"
          onClick={() => showMedalliaFeedbackModal(MEDALLIA_FORM_ID)}
        >
          {feedbackText}
        </Button>
      ) : null}
    </div>
  )
}

export default PartViewerFeedback
